import type { VerticalPageJobType } from 'modules/job-types/types';

type JobTypeDisplayOptions = { shouldUseSEOName: boolean };
export const getJobTypeDisplayName = (
  jobType: VerticalPageJobType,
  { shouldUseSEOName }: JobTypeDisplayOptions = { shouldUseSEOName: false }
) =>
  shouldUseSEOName && jobType.translations.seoName
    ? jobType.translations.seoName
    : jobType.translations.requestType;

export const JOB_TYPE_ID_DEFAULT = 'unknown-jobTypeId';

export const JOB_TYPE_CATEGORIES_DEFAULT = ['unknown-c1', 'unknown-c2', 'unknown-c3'];

export const getIsHomeRequestFormEntry = (jobType: VerticalPageJobType) =>
  jobType.categories.includes('home') &&
  jobType.forms[0] &&
  jobType.forms[0].name === 'propertyType';

export const getIsLearningRequestFormEntry = (jobType: VerticalPageJobType) =>
  jobType.categories.includes('learning') && jobType.forms[0] && jobType.forms[0].name === 'age';

export const getIsBusinessRequestFormEntry = (jobType: VerticalPageJobType) =>
  jobType.categories.includes('business') &&
  jobType.forms[0] &&
  jobType.forms[0].name === 'corporateindividual';

export const getIsSimpleQuestionRequestFormEntry = (jobType: VerticalPageJobType) => {
  const simpleQuestionRequestIdArray = [
    'math-teacher',
    'private-tutor',
    'tennis-instructor',
    'drumming-lessons',
    'electone-instructor',
    'guitar-teacher',
    'karaoke-singing-instructor',
    'piano-teacher',
    'ukulele-instructor',
    'violin-instructor',
    'vocal-instructor',
  ];

  return simpleQuestionRequestIdArray.includes(jobType.id);
};
